import type { ComponentVarianceSummary } from "../../types";
import {
  formatNZD,
  formatNumber,
  formatPercentage,
} from "../../utils/formatters";
import styles from "./TopVarianceTable.module.css";

export interface TopVarianceTableProps {
  components: ComponentVarianceSummary[];
  onComponentClick: (component: string) => void;
}

export function TopVarianceTable({
  components,
  onComponentClick,
}: TopVarianceTableProps) {
  if (components.length === 0) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="top-variance-table">
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.headerCell}>Component</th>
            <th className={styles.headerCell}>Affected Packets</th>
            <th className={styles.headerCell}>Dollar Impact</th>
            <th className={styles.headerCell}>Avg Variance</th>
          </tr>
        </thead>
        <tbody>
          {components.map((comp) => (
            <tr
              key={comp.component}
              className={styles.row}
              onClick={() => onComponentClick(comp.component)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onComponentClick(comp.component);
                }
              }}
              tabIndex={0}
              role="link"
              aria-label={`View ${comp.component} variance details`}
              data-testid="variance-row"
            >
              <td className={styles.cell}>{comp.component}</td>
              <td className={styles.cellNumeric}>
                {formatNumber(comp.affected_packets)}
              </td>
              <td className={styles.cellNumeric}>
                {formatNZD(comp.total_dollar_impact)}
              </td>
              <td className={styles.cellNumeric}>
                {formatPercentage(comp.average_variance)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
